const merge = require('lodash/merge')
const parseRequestMetaData = require('../../utils/parse-request-meta-data')
const getWs02Token = require('@dbk-legacy/wso2token').getToken
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress

function apiFactory({ baseUrl, requestHandler }) {
  const headers = {
    Accept: 'application/json',
  }

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`
  }

  return {
    getFetchChatHistory(inputs, metaData) {
      const url = getUrl('fetchChatHistory')
      const inputParams = inputs.split('#@#')
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData)

      const body = {
        fromUserId: parsedMetaData.qs.userId,
        toUserId: inputParams[0],
        pageNumber: inputParams[1]
      }

      return requestHandler(merge({}, reqOpts, { url, body }, parsedMetaData))
    },

    getFetchUserList(metaData) {
      const url = getUrl('fetchUserList')
      const reqOpts = { headers, method: 'POST', json: true }
      const parsedMetaData = parseRequestMetaData(metaData.metaData)

      const body = {
        userId: parsedMetaData.qs.userId
      }

      return requestHandler(merge({}, reqOpts, { url, body }, parsedMetaData))
    },

  }
}

module.exports = apiFactory
